// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1yqNO","label":"styles_label__17lmU"};